import { Component, OnInit, Injector, Input, ElementRef } from '@angular/core';
import { LayoutService } from '../../../Services/layout/layout.service';
import { StoreService } from '../../../Services/store';
import { AccordionHelperService } from '../../../Services/accordion-helper/accordion-helper';
import { ObservablesService } from '../../../Services/observables/observables';
import { get, chain, forEach } from 'lodash';
import { SplunkAnalyticsService } from '../../../Services/splunk-analytics/splunk-analytics-service';
import { ActionApiService } from '../../../Services/action-api/action-api.service';

@Component({
	selector: 'progress-accordion',
	template: `
		<div *ngIf="isVisiable">
			<div *ngFor="let section of sections" class="completed-section-container">
				<div class="completed-section clearfix">
					<div class="title">{{ section.title.toLowerCase() }}</div>
					<div class="subtitle">{{ getSectionSubtitle(section) }}</div>
					<button
						class="editpencil"
						[attr.name]="setName(section)"
						aria-label="Edit"
						(click)="ajaxAction(section.name, section.ajaxInfo.action, 'page', section.ajaxInfo.stage)"
						gtm-handler
						events="click"
						handlerType="dataValue"
						label="{{ getGtmLabel(section.title) }}"
						value="getStageName()"
						action="ButtonClick"
						[attributeVal]="getGtmLabel(section.title)"
					>
						<span> </span><i class=""></i>
					</button>
				</div>
			</div>
		</div>
	`,
	styleUrls: ['./progress-accordion.component.scss'],
})
export class ProgressAccordionComponent implements OnInit {
	progressMeter: progressMeter;
	sections: section[];
	ajaxInfo: any;
	offMetadataUpdated: any;
	cachedSections: any;
	isVisiable = true;

	constructor(
		private LayoutService: LayoutService,
		private storeService: StoreService,
		private el: ElementRef,
		private observablesService: ObservablesService,
		private accordionHelperService: AccordionHelperService,
		private splunkAnalyticsService: SplunkAnalyticsService,
		private actionService: ActionApiService
	) {}

	ngOnInit() {
		this.LayoutService.staticLayout.subscribe((data) => {
			if (data) {
				// handle flag showing the old mobile progress meter or the new (new located in header.component)
				if (data.data.metadata && data.data.metadata.progressMeter && !(window.innerWidth > 768)) {
					this.isVisiable = false;
				}

				this.progressMeter = data.data.metadata.progressMeter;

				this.sections = this.getfilteredSections(this.progressMeter);
			}
		});

		this.listenToMetadataUpdated();
	}

	getGtmLabel(title) {
		return title + '_Edit';
	}

	getfilteredSections(progressMeter: progressMeter) {
		if (!progressMeter || !progressMeter.visible) {
			return [];
		}

		this.sections = [];

		forEach(progressMeter.sections, (section) =>
			section.states
				? this.sections.push(section) && forEach(section.states, (state) => this.sections.push(state))
				: this.sections.push(section)
		);

		return chain(this.sections)
			.map((section) => [section])
			.flatten()
			.filter((section) => section.completed && section.AccordionDisplay == null)
			.value();
	}

	listenToMetadataUpdated() {
		this.observablesService.pageUpdated.subscribe(() => {
			if (!this.progressMeter) {
				return;
			}
			this.cachedSections = this.accordionHelperService.getfilteredSections(this.progressMeter);
		});
	}

	ajaxAction(elementSrc, action, context, stage) {
		this.ajaxInfo = {
			elementSrc: elementSrc,
			action: action,
			stage: stage,
		};

		this.splunkAnalyticsService.publish('Progress Bar', stage, stage);
		return this.actionService.ajaxAction(this.ajaxInfo, context);
	}

	getSectionSubtitle(section) {
		return this.storeService.getDynamicContent(`StageSummary.${section.name}`);
	}

	setName(section) {
		return 'Edit_' + section.name;
	}
}
